import React from "react";
import PropTypes from "prop-types";
import {Modal} from "../../components/Modal";
import {i18nFormat} from "../../lib/i18nFormat";

export function SelfHostedServerDeleteDialog(props) {
  if (!props.isOpen) {
    return null;
  }

  function getContent() {
    if (props.server.selfHostedServerSubscriptionType === "lifetime") {
      return (
        <>
          <div className="account-shs-delete-dialog__icon-wrapper account-shs-delete-dialog__icon-wrapper--warning">
            <div className="glyph-core-exclamationmark-triangle-fill"/>
          </div>
          <h2 className="account-shs-delete-dialog__title">
            {i18nFormat("shs.delete-dialog.title-not-allowed", {serverName: props.server.name})}
          </h2>
          <p className="account-shs-delete-dialog__description">
            {i18nFormat("shs.delete-dialog.description-not-allowed-lifetime")}
          </p>
          <button className="gradient-button-blue" onClick={props.onClose}>
            {i18nFormat("shs.delete-dialog.got-it")}
          </button>
        </>
      );
    } else if (props.server.selfHostedServerSubscriptionType === "monthly" && props.server.selfHostedServerSubscriptionActive === true) {
      return (
        <>
          <div className="account-shs-delete-dialog__icon-wrapper account-shs-delete-dialog__icon-wrapper--warning">
            <div className="glyph-core-exclamationmark-triangle-fill"/>
          </div>
          <h2 className="account-shs-delete-dialog__title">
            {i18nFormat("shs.delete-dialog.title-not-allowed", {serverName: props.server.name})}
          </h2>
          <p className="account-shs-delete-dialog__description">
            {i18nFormat("shs.delete-dialog.description-not-allowed-active")}
          </p>
          <button className="gradient-button-blue" onClick={props.onManageSubscription}>
            {i18nFormat("shs.delete-dialog.manage-subscription")}
          </button>
        </>
      );
    } else {
      return (
        <>
          <div className="account-shs-delete-dialog__icon-wrapper account-shs-delete-dialog__icon-wrapper--delete">
            <div className="glyph-core-trash-fill"/>
          </div>
          <h2 className="account-shs-delete-dialog__title">
            {i18nFormat("shs.delete-dialog.title", {serverName: props.server.name})}
          </h2>
          <p className="account-shs-delete-dialog__description">
            {i18nFormat("shs.delete-dialog.description")}
          </p>
          <div className="account-shs-delete-dialog__buttons">
            <button className="account-shs-delete-dialog__cancel-button" onClick={props.onClose}>
              {i18nFormat("shs.delete-dialog.cancel")}
            </button>
            <button className="account-shs-delete-dialog__delete-button" onClick={handleDeleteConfirmClick}>
              {i18nFormat("shs.delete-dialog.delete-server")}
            </button>
          </div>
        </>
      );
    }
  }

  function handleDeleteConfirmClick() {
    props.onClose();

    Promise.resolve().then(async () => {
      await window.hyWebsite.cloudApi.deleteHomeySelfHostedServer({
        homeyId: props.server.id,
      });

      await window.hyWebsite.cloudApi.refreshUser();
    }).catch(error => alert(error));
  }

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="account-shs-delete-dialog">
        <button className="account-shs-delete-dialog__close-button glyph-core-cross" onClick={props.onClose}>
        </button>
        {getContent()}
      </div>
    </Modal>
  );
}

SelfHostedServerDeleteDialog.propTypes = {
  server: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    selfHostedServerSubscriptionActive: PropTypes.bool.isRequired,
    selfHostedServerSubscriptionType: PropTypes.oneOf(["trial", "lifetime", "monthly"]).isRequired,
    selfHostedServerSubscriptionExpiresAt: PropTypes.string,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onManageSubscription: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};